import { render, staticRenderFns } from "./DocumentSalesErrorListWO.vue?vue&type=template&id=c5195450&scoped=true"
import script from "./DocumentSalesErrorListWO.vue?vue&type=script&lang=js"
export * from "./DocumentSalesErrorListWO.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5195450",
  null
  
)

export default component.exports